import type { BillingTransactionsQueryParams } from "./useBillingTransactionsQuery";

export const BILLING_QUERY_KEYS = {
  all: ["BILLING"] as const,
  balance: () => [...BILLING_QUERY_KEYS.all, "BALANCE"] as const,
  transactions: (params: BillingTransactionsQueryParams) =>
    [...BILLING_QUERY_KEYS.all, "TRANSACTIONS", params] as const,
} as const;
